export default __webpack_public_path__ + "static/media/i057jk.93ea942f.webp";